export default __webpack_public_path__ + "static/media/godfather.1bd7e4b2.png";